<template>
  <div class="c-role-detail__permissions">
    <div
      v-for="(resource, resourceIndex) in visibleResources"
      :key="`resource_${resourceIndex}`"
      class="permission-item"
    >
      <RoleDetailPermissionSelect :resource :role-id :view-only />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoleResources } from '@/composables/useRoleResources';

import RoleDetailPermissionSelect from './RoleDetailPermissionSelect.vue';

const { roleId, viewOnly = false } = defineProps<{
  roleId?: string;
  viewOnly?: boolean;
}>();

const { visibleResources } = useRoleResources();
</script>

<style lang="pcss">
@reference "../css/theme.css";
.c-role-detail__permissions {
  max-height: 315px;
  min-height: 170px;
  overflow-y: scroll;
  @apply mb-16 pt-1 pr-1;
}

.permission-item {
  @apply text-base mb-16 flex justify-between items-center;
}

.u-grey-box {
  border-radius: 3px;
  @apply border border-neutral-200;
  &:focus {
    @apply border-brand-teal;
  }
  &:focus-within {
    @apply border-brand-teal;
  }
}

.c-edit-role__permission-detail {
  @apply flex flex-col border border-neutral-200 p-20;
}
.c-edit-role__permission-select {
  @apply bg-neutral-200 w-120 h-25 flex justify-between items-center;
  border-radius: 2px;
}
</style>
